// src/graphqlOps.js
export const PendingReservations = /* GraphQL */ `
  query PendingReservations {
    listReservations(limit: 1000, filter: { approvalStatus: { eq: PENDING } }) {
      items { id CompanyId carId title start end approvalStatus }
    }
  }
`;
export const ProposeChange = /* GraphQL */ `
  mutation ProposeChange($input: ProposeChangeInput!) {
    proposeChange(input: $input) {
      id
      CompanyId
      entity
      op
      targetId
      status
      createdAt
      submittedBySub
      submittedByEmail
      createdAt
    }
  }
`;


export const PendingMaintenance = /* GraphQL */ `
  query PendingMaintenance {
    listMaintenances(limit: 1000, filter: { approvalStatus: { eq: PENDING } }) {
      items { id CompanyId carId title start end approvalStatus }
    }
  }
`;

// PENDING CHANGE REQUESTS (scoped by company, filter by status)
// We DON'T pass a top-level 'status' arg. We filter it.
export const PendingChangeRequests = /* GraphQL */ `
  query PendingChangeRequests(
    $CompanyId: String!,
    $createdAt: ModelAWSDateTimeKeyConditionInput,
    $limit: Int = 1000,
    $nextToken: String
  ) {
    changeRequestsByCompanyByStatus(
      CompanyId: $CompanyId,
      createdAt: $createdAt,
      limit: $limit,
      nextToken: $nextToken,
      filter: { status: { eq: PENDING } }
    ) {
      items { id entity op targetId submittedByEmail payload CompanyId createdAt }
      nextToken
    }
  }
`;

// If you want a systemwide admin queue (all companies), use list + filter:
export const PendingChangeRequestsAll = /* GraphQL */ `
  query PendingChangeRequestsAll($limit: Int = 1000, $nextToken: String) {
    listChangeRequests(
      limit: $limit,
      nextToken: $nextToken,
      filter: { status: { eq: PENDING } }
    ) {
      items { id entity op targetId submittedByEmail payload CompanyId createdAt }
      nextToken
    }
  }
`;

export const ApproveReservation = /* GraphQL */ `
  mutation ApproveReservation($id: ID!) {
    approveReservation(id: $id) { id approvalStatus }
  }
`;

export const RejectReservation = /* GraphQL */ `
  mutation RejectReservation($id: ID!, $reason: String) {
    rejectReservation(id: $id, reason: $reason) { id approvalStatus }
  }
`;

export const ApproveMaintenance = /* GraphQL */ `
  mutation ApproveMaintenance($id: ID!) {
    approveMaintenance(id: $id) { id approvalStatus }
  }
`;

export const RejectMaintenance = /* GraphQL */ `
  mutation RejectMaintenance($id: ID!, $reason: String) {
    rejectMaintenance(id: $id, reason: $reason) { id approvalStatus }
  }
`;

export const ApproveChange = /* GraphQL */ `
  mutation ApproveChange($id: ID!) {
    approveChange(id: $id) { id status approvedAt approvedBySub }
  }
`;

export const RejectChange = /* GraphQL */ `
  mutation RejectChange($id: ID!, $reason: String) {
    rejectChange(id: $id, reason: $reason) { id status reason }
  }
`;
